module.exports = __webpack_public_path__ + "akne_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_2_before.jpg
// module id = 918
// module chunks = 0